import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../../components/header';
import Footer from '../../components/footer';
import Confetti from 'react-confetti';
import { useAppDispatch } from '../../state/hooks';
import { loginSuccess } from '../../state/auth';
import { api } from '../../api/api';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const RewardClaimPage = () => {
  const [rewardAsset, setRewardAsset] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [currentUser, setCurrentUser] = useState<any>(null);
  const [showConfetti, setShowConfetti] = useState(true);
  const location = useLocation();

  const dispatch = useAppDispatch();

  useEffect(() => {
    // Auto-login check
    const checkSession = async () => {
      const token = localStorage.getItem('accessToken');
      if (token) {
        // Make token available for other parts of the app that might use the key 'token'
        localStorage.setItem('token', token);
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        try {
          const meResponse = await api.get('/api/users/me');
          setCurrentUser(meResponse.data);
          // Dispatch login success to update global state
          dispatch(loginSuccess(meResponse.data.name));

          // Fetch and log user assets
          const assetsResponse = await api.get('/api/users/me/assets');
          console.log('User assets:', assetsResponse.data);
        } catch (error) {
          console.error('Failed to fetch user session:', error);
          // Optional: handle invalid token, e.g., redirect to login
        }
      }
    };
    checkSession();

    // Fetch reward details
    const params = new URLSearchParams(location.search);
    const rewardId = params.get('rewardId');

    if (rewardId) {
      const fetchRewardDetails = async () => {
        try {
          setIsLoading(true);
          const response = await api.get(`/api/giveaways/reward/${rewardId}/asset`);
          setRewardAsset(response.data);
        } catch (err) {
          setError('Failed to load reward details. Please check the code and try again.');
        } finally {
          setIsLoading(false);
        }
      };
      fetchRewardDetails();
    } else {
      setError('No reward ID provided.');
      setIsLoading(false);
    }

    // Stop confetti after some time
    const confettiTimer = setTimeout(() => {
      setShowConfetti(false);
    }, 8000); // 8 seconds

    return () => clearTimeout(confettiTimer);
  }, [location.search, dispatch]);

  return (
    <div style={{ backgroundImage: "url(/assets/img/auth/bg.png)", backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center" }} className={`relative w-full min-h-screen flex flex-col items-center text-white`}>
      {showConfetti && <Confetti numberOfPieces={400} gravity={0.1} colors={['#ff0', '#f0f', '#0ff', '#fff']} />}
      <Header />
      <div className="w-full md:w-[676px] h-full flex flex-col items-center mt-5 z-10 mb-[166px]">
        <img alt="modal-logo" src="/assets/img/login/logo.png" className="w-[252px] md:w-[276px] mb-8" />
        <div className="w-full max-w-md p-8 space-y-6 bg-black bg-opacity-80 rounded-md">
          <h1 className="text-3xl font-bold text-center">Reward Claimed!</h1>
          {isLoading && <p className="text-center">Loading your reward...</p>}
          {error && <p className="text-center text-red-500">{error}</p>}
          {rewardAsset && (
            <div className="text-center">
              <h2 className="text-2xl font-semibold">You have won:</h2>
              <p className="text-xl my-4">{rewardAsset.name}</p>
              {rewardAsset.image_path && <img src={`${API_URL}/uploads/${rewardAsset.image_path}`} alt={rewardAsset.name} className="mx-auto my-4 rounded-md" style={{maxWidth: '300px'}} />}
              <p className="text-gray-400">This item has been added to your account, {currentUser?.name || 'winner'}!</p>
            </div>
          )}
        </div>
      </div>
      <div className="md:w-[676px] w-full h-full absolute bg-black bg-opacity-93"></div>
      <div className="w-full flex absolute bottom-0">
        <Footer type="sm" />
      </div>
    </div>
  );
};

export default RewardClaimPage;